import { QueryConfig } from "store/utils/query-config";

export const campaignsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
